import { Component } from '@angular/core';

import {
  Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router'
import {NgZone, Renderer2, ElementRef, ViewChild} from '@angular/core'
import { LoadingSpinnerService } from './_services/loading-spinner.service';

import { SocketService } from './_services/socket.service';
import { UserService } from './_services/user.service';
import { NotificationAPIService, NotificationService } from './_services/notification.service';
import { LongProgressService } from './_services/long-progress.service';
import { Observable, Subscription, fromEvent } from 'rxjs';

declare var CKEDITOR;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  objLoaderStatus: boolean;
  public socket;

  // Instead of holding a boolean value for whether the spinner
  // should show or not, we store a reference to the spinner element,
  // see template snippet below this script
  @ViewChild('spinnerElement', {static: false})
  spinnerElement: ElementRef
  
  isConnected = true;
  connectionStatus = 'online'
  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  closeDeploymentMessage = false;

  deployment_running = false;
  deployment_message= '' ;
  alertTab = false;
  deploymentEvent: Observable<Event>;
  tabStatusEventSubscription: Subscription;

  constructor(private router: Router,
              private ngZone: NgZone,
              private renderer: Renderer2,
              public _socketService: SocketService,
              private _notificationServie: NotificationAPIService,
              private longProgressService: LongProgressService,
              private notificationServie: NotificationService
              ) {
    router.events.subscribe((event: RouterEvent) => {
      this._navigationInterceptor(event)
    })
    this.objLoaderStatus = false;
  }

  ngOnInit() {
    CKEDITOR.dtd.a.div = 1;
    CKEDITOR.dtd.a.p = 1;

    // Check internet connectivity.
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.onlineEvent.subscribe(e => {
      this.connectionStatus = 'online';
      this.isConnected = true;
      // window.location.reload()
    });

    this.offlineEvent.subscribe(e => {
      this.connectionStatus = 'offline';
      this.isConnected = false;
    })


    this._notificationServie.showDeploymentNotificaticationEvent.subscribe(e => {
      if(this.alertTab) {
        this.closeDeploymentMessage = true;
      } else {
        this.deployment_running = e.deployment_running;
      }
      this.deployment_message = e.deployment_message;
    });

    this.progressTabCheck();

  }

  ngOnDestroy() {
    this.tabStatusEventSubscription.unsubscribe();
  }

  // Shows and hides the loading spinner during RouterEvent changes
  private _navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      // We wanna run this function outside of Angular's zone to
      // bypass change detection
      this.ngZone.runOutsideAngular(() => {
        // For simplicity we are going to turn opacity on / off
        // you could add/remove a class for more advanced styling
        // and enter/leave animation of the spinner
        // this.loaderService.showLoader(true);
        this.renderer.setStyle(
          this.spinnerElement.nativeElement,
          // 'opacity',
          // '1'
          'display', 'block'
        )
      })
    }
    if (event instanceof NavigationEnd) {
      // this.loaderService.showLoader(false);
      this._hideSpinner()
    }
    // Set loading state to false in both of the below events to
    // hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      // this.loaderService.showLoader(false);
      this._hideSpinner()
    }
    if (event instanceof NavigationError) {
      // this.loaderService.showLoader(false);
      this._hideSpinner()
    }
  }

  private _hideSpinner(): void {
    // We wanna run this function outside of Angular's zone to
    // bypass change detection,
    this.ngZone.runOutsideAngular(() => {
      // For simplicity we are going to turn opacity on / off
      // you could add/remove a class for more advanced styling
      // and enter/leave animation of the spinner
      this.renderer.setStyle(
        this.spinnerElement.nativeElement,
        // 'opacity',
        // '0'
        'display', 'none'
      )
    })
  }

  progressTabCheck() {
    this.tabStatusEventSubscription = this.longProgressService.currentNotificationTab.subscribe(content => {
      if(content.currentTab == "alerts") {
        this.alertTab = true;
         if(this.deployment_running) {
           this.closeDeploymentMessage = true;
         }
      } else {
        this.alertTab = false;
      }
    })
  }
}
